export function VoiceReadiness({ ready }: { ready: boolean }) {
  return <div className={`voice-readiness ${ready ? "is-ready" : "is-starting"}`} role="status" aria-live="assertive">
    <span className="voice-readiness-dot" aria-hidden="true" />
    <strong>{ready ? "Можно говорить" : "Включаю микрофон…"}</strong>
  </div>;
}
